import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { resolveFunnelUrlByMonetizationTest } from '@/helpers';
import { landingHairStyleChangerConfig } from '@/data/landingConfig/landingHairStyleChangerConfig';
import { MONETIZATION_TEST } from '@/constants';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiHairstyle } from './schemaObject';

interface Props {}
const HairStyleChanger: React.FC<Props> = () => {
	const funnelUrl = resolveFunnelUrlByMonetizationTest(
		{ [MONETIZATION_TEST.NON_TIER_1]: GenerateLandingLinkService.funnelHairStyleV3 },
		GenerateLandingLinkService.funnelHairStyle,
	);

	return (
		<>
			<AggregateSchema schema={schemaObject_AiHairstyle} />
			<LandingTemplate
				data={landingHairStyleChangerConfig}
				funnelLinkService={funnelUrl}
			/>
		</>
	);
};

export default HairStyleChanger;
